import { useShiftEditor } from '../useShiftEditor'
import { useCompanyPosition } from 'hooks/useCompanyPosition'
import { Heading, Text } from 'ui'
import styled from 'styled-components'
import { PreviewCard } from './styles'

const AboutText = styled(Text)`
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export function AboutSection() {
  const { shiftData } = useShiftEditor()
  const position = useCompanyPosition(shiftData?.details?.positionId)
  const about = position?.about?.trim()

  if (!about) return null

  return (
    <PreviewCard>
      <Heading level={4} my={0} mb={2}>
        About
      </Heading>
      <AboutText>{about}</AboutText>
    </PreviewCard>
  )
}
